import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { bibleNavigationLinks, colors } from "./constants";
import { Link } from "@inertiajs/react";
import { HideChromeButton, useChromePart } from "./ChromeVisibility";

export interface NavigationItemProps {
  icon?: any;
  iconJsx?: any;
  label: string;
  selected?: boolean;
  href?: string;
  style?: any
}

export function NavigationItem({ icon, iconJsx, label, selected, href, style = {} }: NavigationItemProps) {
  const parentStyle = {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',

    backgroundColor: selected ? 'var(--active-button-background)' : colors['buttonBackground'],
    borderColor: selected ? 'var(--active-button-border)' : colors['buttonBorder'],
    color: selected ? 'var(--active-button-text)' : colors['buttonText'],


    border: '1px solid',
    width: '100%',
    gap: '12px',
    aspectRatio: '1 / 1',
    ...style
  }

  const itemContent = (
    <>
      {iconJsx ? iconJsx : (
        <FontAwesomeIcon icon={icon} />
      )}
      <div style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: '14px',
        lineHeight: '14px',
        textWrap: 'wrap',
        textAlign: 'center',
      }}>
        {label}
      </div>
    </>
  )

  if (href) {
    return (
      <Link href={href} style={{ textDecoration: 'none', ...parentStyle }}>
        {itemContent}
      </Link>
    )
  }

  return (
    <div style={parentStyle}>
      {itemContent}
    </div>
  )
}

export default function NavigationBar() {
  const [hidden, setHidden] = useChromePart('rail')

  if (hidden) { return null }

  return (
    <div style={{
      height: '100%',
      width: '75px',
      backgroundColor: colors['navigationBackground'],
      display: 'flex',
      flexDirection: 'column',
      borderRight: `1px solid ${colors['borderColor']}`,
    }}>
      <div style={{
        display: 'flex',
        flexDirection: 'column',
        padding: '4px',
        gap: '4px',
      }}>
        <div style={{
          display: 'flex',
          justifyContent: 'flex-end',
        }}>
          <HideChromeButton
            onHide={() => setHidden(true)}
            label="Hide navigation rail"
            style={{ color: colors['borderColor'] }}
          />
        </div>
        <div style={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          gap: '4px',
          width: '100%',
        }}>
          {bibleNavigationLinks.map((navigationLink) => (
            <NavigationItem
              key={navigationLink.href}
              icon={navigationLink.icon}
              label={navigationLink.label}
              selected={navigationLink.selected(window.location.pathname)}
              href={navigationLink.href}
            />
          ))}
        </div>
      </div>
    </div >
  )
}

export function MobileBottomNavigationBar() {
  return (
    <div style={{
      width: '100%',
      height: '50px',
      padding: '4px',
      borderTop: `1px solid ${colors['borderColor']}`,
      backgroundColor: colors['navigationBackground'],

      display: 'flex',
      flexDirection: 'row',
      gap: '4px',
      justifyContent: 'space-between',
    }}>
      {bibleNavigationLinks.map((navigationLink) => (
        <NavigationItem
          key={navigationLink.href}
          icon={navigationLink.icon}
          label={navigationLink.label}
          selected={navigationLink.selected(window.location.pathname)}
          href={navigationLink.href}
          style={{ gap: '4px', flex: 1, aspectRatio: 'none' }}
        />
      ))}
    </div>
  )
}
